import Locales from './fr';

export default Locales;
